import { Select } from "antd";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  width: 100%;
`;

/**
 * Display component for select values
 * Handles: arrays, single value
 */
function UdfSelectDisplay({ value }) {
  // Handle array of values
  if (Array.isArray(value)) {
    return (
      <>
        {value.map((val, index) => (
          <span key={index}>
            {String(val)}
            {index < value.length - 1 && ", "}
          </span>
        ))}
      </>
    );
  }

  return String(value);
}

/**
 * Select input component for UDF filters
 */
function UdfSelectEdit({ addValue, currentValue, setCurrentValue, choices = [] }) {
  return (
    <StyledSelect
      popupMatchSelectWidth={false}
      placeholder="Select an option to add..."
      value={currentValue ?? null}
      onChange={(value) => {
        if (value) {
          addValue(value);
          setCurrentValue(null);
        }
      }}
      options={choices.map((choice) => ({
        label: choice,
        value: choice,
      }))}
      showSearch
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
    />
  );
}

/**
 * Factory function that returns both Edit and Display components
 */
function UdfSelect() {
  return {
    Edit: UdfSelectEdit,
    Display: UdfSelectDisplay,
  };
}

export default UdfSelect;
